<template>
  <div>
    <div class="mx-2">
      <div class="row">
        <div class="col-md-12">
          <div class="d-flex justify-content-end">
            <label for="" class="mt-4 tamaño"> Buscar:</label>
            <input class="form-control form-control-lg w-25 me-0 ms-2 mt-3 tamaño" type="text"
              aria-label=".form-control-lg example" v-model="dni_busqueda" />
          </div>

            <div class="mt-2 ms-2 tamaño">
              (*) Solo escoger el estado de
              <strong class="text-success"> SELECCIONADO </strong> cuando estén
              terminadas todas las etapas de:<strong>
                Selección, Entrevista, Documentos y Capacitación.
              </strong>
            </div>

          <div class="table-responsive mt-3">
            <div>
              <table class="table table-bordered">
                <thead class="tamaño">
                  <tr class="bg-solimano  text-center text-white">
                    <th colspan="4"></th>
                    <th colspan="2">SELECCION</th>
                    <th colspan="2">ENTREVISTA</th>
                    <th colspan="2">DOCUMENTO</th>
                    <th colspan="2">CONTRATOS</th>
                    <th colspan="2">CAPACITACION</th>                  

                    
                    <th colspan="5"></th>
                  </tr>
                  <tr class="bg-solimano text-white text-center">
                    <th scope="col">ID</th>
                    <th scope="col">REF.</th>
                    <th scope="col">POSTULANTE</th>
                    <th scope="col">ESTADO</th>

                    <th selector scope="col">ETAPA</th>

                    <th scope="col">FECHA EJECUTADA</th>
                    <th scope="col">ETAPA</th>
                    <th scope="col">FECHA EJECUTADA</th>
                    <th scope="col">ETAPA</th>
                    <th scope="col">FECHA EJECUTADA</th>
                    <th scope="col">ETAPA</th>
                    <th scope="col">FECHA EJECUTADA</th>
                    <th scope="col">ETAPA</th>
                    <th scope="col">FECHA EJECUTADA</th>
                    <!-- <th scope="col" class="text-nowrap px-5">
                      OBSERVACION POSTULANTE
                    </th> -->
                    <!-- <th scope="col" class="text-nowrap px-5">DETALLE</th> -->
                    <!-- <th scope="col">ACCION</th> -->
                    <th scope="col">
                      <i class="bi bi-boxes fs-5"></i>
                    </th>
                    <th scope="col">FEC.INIC.CONTRATO</th>
                    <th scope="col">FEC.FIN.CONTRATO</th>
                    <!-- <th scope="col">ACCION</th> -->
                  </tr>
                </thead>
                <tbody class="text-nowrap tamaño text-center align-middle" v-for="post in paginatedInfo"
                  :key="post.idSolxPostulante">
                  <tr>
                    <th scope="row">{{ post.idSolxPostulante }}</th>
                    <td class="text-center">
                      <!-- <button
                        :disabled="permisoVisualizador == 2 ? false : true"
                        class="btn border-0"
                      >
                      <i
                            class="bi bi-star-fill"
                            @click="cambiarReferido(post.idSolxPostulante)"
                            :class="{
                              'text-warning ': post.solReferido,
                              'text-secondary ': !post.solReferido,
                            }"
                          ></i>
                      </button> -->
                      {{ post.solfuente }}
                    </td>
                    <td class="text-nowrap">{{ post.nombre }}</td>
                    <td class="text-nowrap tamaño text-center align-middle">
                      <span :class="{
                        'text-success': post.solPosMotivo == '010',
                        'text-danger':
                          post.solPosMotivo != '010' &&
                          post.solPosMotivo != '011',
                        'text-primary ': post.solPosMotivo == '011',
                      }" class="">
                        {{ post.solDesMotivo }}</span>
                    </td>
                    <!-- <td>
                      <button
                        @click="CrearUser(post.idMaePostulante)"
                        :disabled="permisoVisualizador == 2 ? false : true"
                        class="btn btn-primary"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          class="bi bi-person-plus-fill"
                          viewBox="0 0 16 16"
                        >
                          <path
                            d="M1 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
                          />
                          <path
                            fill-rule="evenodd"
                            d="M13.5 5a.5.5 0 0 1 .5.5V7h1.5a.5.5 0 0 1 0 1H14v1.5a.5.5 0 0 1-1 0V8h-1.5a.5.5 0 0 1 0-1H13V5.5a.5.5 0 0 1 .5-.5z"
                          />
                        </svg>
                      </button>
                    </td> -->

                    <td>
                      <button @click="editSeleccion(post.idSolxPostulante)" :class="{
                        'btn btn-warning py-1 my-0': !post.solPosSeleccion,
                        'btn btn-success py-1 my-0': post.solPosSeleccion,
                      }">
                        <i v-if="post.solPosSeleccion" class="bi bi-check-circle"></i>

                        <i v-if="!post.solPosSeleccion" class="bi bi-person-bounding-box"></i>
                      </button>
                    </td>
                    <td class="text-center" v-if="post.solFecSelEjec.slice(0, 4) == 1900">
                      --
                    </td>
                    <td v-else>{{ post.solFecSelEjec.slice(0, 10) }}</td>
                    <td>
                      <button @click="editEntrevista(post.idSolxPostulante)" :class="{
                        'btn btn-warning py-1 my-0': !post.solPosEntrevista,
                        'btn btn-success py-1 my-0': post.solPosEntrevista,
                      }">
                        <i v-if="post.solPosEntrevista" class="bi bi-check-circle"></i>

                        <i v-if="!post.solPosEntrevista" class="bi bi-headset"></i>
                      </button>
                    </td>
                    <td class="text-center" v-if="post.solFecEntEjec.slice(0, 4) == 1900">
                      --
                    </td>
                    <td v-else>{{ post.solFecEntEjec.slice(0, 10) }}</td>
                    <td>
                      <button @click="editDocumentos(post.idSolxPostulante)" :class="{
                        'btn btn-warning py-1 my-0': !post.solPosDocumento,
                        'btn btn-success py-1 my-0': post.solPosDocumento,
                      }">
                        <i v-if="post.solPosDocumento" class="bi bi-check-circle"></i>

                        <i v-if="!post.solPosDocumento" class="bi bi-folder2-open"></i>
                      </button>
                    </td>
                    <td v-if="post.solFecDocEjec.slice(0, 4) == 1900">--</td>
                    <td v-else>{{ post.solFecDocEjec.slice(0, 10) }}</td>               
                  
                   <td>
                      <button @click="editContrato(post.idSolxPostulante)" :class="{
                        'btn btn-warning py-1 my-0 ': !post.solPosContratos,
                        'btn btn-success py-1 my-0': post.solPosContratos,
                      }">
                        <i v-if="post.solPosContratos" class="bi bi-check-circle"></i>
                        <i v-if="!post.solPosContratos" class="bi bi-vector-pen"></i>
                      </button>
                    </td>

                    <td v-if="post.solFecConEjec.slice(0, 4) == 1900">--</td>
                    <td v-else>{{ post.solFecConEjec.slice(0, 10) }}</td>

                     <td>
                      <button @click="editCapacitaciones(post.idSolxPostulante)" :class="{
                        'btn btn-warning py-1 my-0': !post.solPosCapacitacion,
                        'btn btn-success py-1 my-0': post.solPosCapacitacion,
                      }">
                        <i v-if="post.solPosCapacitacion" class="bi bi-check-circle"></i>
                        <i v-if="!post.solPosCapacitacion" class="bi bi-camera-reels"></i>
                      </button>
                    </td>

                    <td v-if="post.solFecCapEjec.slice(0, 4) == 1900"></td>
                    <td v-else>{{ post.solFecCapEjec.slice(0, 10) }}</td>


                    <td class="d-flex">
                      <b-button v-b-modal.modal-center5 :class="{
                        'btn btn-light border border-1':
                          post.solComentario == '',
                        'btn btn-danger': post.solComentario != '',
                      }">
                        <i class="bi bi-chat-dots"></i>
                      </b-button>

                      <button @click="
                        CrearUser(
                          post.idMaePostulante,
                          post.nombre.slice(21, post.nombre.length),
                          post.posNroDocumento,
                          post.idSolxPostulante
                        )
                        " :disabled="permisoVisualizador == 2 ? false : true"
                        class="btn btn-light border border-1 py-1 my-0 ms-2">
                        <i class="bi bi-person-add"></i>
                      </button>

                      <!-- <button
                          class="btn btn-success ms-2 py-1 my-0"
                          @click="
                            mandarComentarios(
                              post.idSolxPostulante,
                              post.solPosMotivo,
                              post.solComentario
                            )
                          "
                        >
                          <i class="bi bi-floppy"></i>
                        </button> -->
                      <button v-if="permisoVisualizador == 2" class="btn btn-light ms-2 border border-1 py-1 my-0"
                        @click="mandarEstadoPostulanteXcorreo(post)">
                        <i class="bi bi-envelope-at"></i>
                      </button>
                    </td>


                    <td>
                      <input type="date" class="form-control tamaño" aria-describedby="emailHelp" :min="fechaMinima"
                        v-model="post.fecIniContrato" @change="datosIni(post)" />
                    </td>

                    <td>
                      <input type="date" class="form-control tamaño" aria-describedby="emailHelp" :min="fechaMinima"
                        v-model="post.fecFinContrato" @change="datosFin(post)" />
                    </td>

                    <!-- <td>
                      <button
                        class="btn btn-success"
                        @click="actualizarFec(post.idSolxPostulante)"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="currentColor"
                          class="bi bi-save"
                          viewBox="0 0 16 16"
                        >
                          <path
                            d="M2 1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H9.5a1 1 0 0 0-1 1v7.293l2.646-2.647a.5.5 0 0 1 .708.708l-3.5 3.5a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L7.5 9.293V2a2 2 0 0 1 2-2H14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h2.5a.5.5 0 0 1 0 1H2z"
                          />
                        </svg>
                      </button>
                    </td> -->
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- tabla2 -->
            <b-modal size="lg" id="modal-center5" centered title="COMENTARIOS" body-class="custom-modal-body">
              <div class="d-flex w-100 h mt-2">
                <b-form-textarea v-if="permisoVisualizador == 10" class="py-0 my-0"></b-form-textarea>

                <b-form-textarea v-else class="my-0 py-1" disabled></b-form-textarea>

                <button class="btn btn-success my-auto ms-2">
                  <i class="bi bi-floppy"></i>
                </button>
              </div>
            </b-modal>

            <div v-if="
              dni_busqueda.length === 2 || dni_busqueda.length === 1
                ? true
                : false
            " class="text-center container overflow-hidden mt-5">
              <b-spinner variant="primary"></b-spinner>
              buscado .......
            </div>
          </div>

          <div class="pagination-container d-flex justify-content-center align-items-center gap-2 my-3">
            <!-- Primera página -->
            <button class="btn btn-outline-primary btn-sm" @click="currentPage = 1" :disabled="currentPage === 1">
              <i class="bi bi-chevron-double-left"></i>
            </button>

            <!-- Retroceder -->
            <button class="btn btn-outline-primary btn-sm" @click="currentPage--" :disabled="currentPage === 1">
              <i class="bi bi-chevron-left"></i>
            </button>

            <!-- Página actual -->
            <span class="pagination-info fw-bold">
              Página {{ currentPage }} de {{ totalPages }}
            </span>

            <!-- Avanzar -->
            <button class="btn btn-outline-primary btn-sm" @click="currentPage++"
              :disabled="currentPage === totalPages">
              <i class="bi bi-chevron-right"></i>
            </button>

            <!-- Última página -->
            <button class="btn btn-outline-primary btn-sm" @click="currentPage = totalPages"
              :disabled="currentPage === totalPages">
              <i class="bi bi-chevron-double-right"></i>
            </button>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
// import Swal from "sweetalert2";

export default {
  name: "SolimanologTablaSeguimientoSolicitud",

  data() {
    return {
      referido: true,
      info: [],
      dni_busqueda: "",
      form: { solComentario: "" },
      forms: {
        IdSolxPostulante: "",
        FecIniContratos: "",
        FecFinContratos: "",
        idUsuario: "",
      },
      permisoVisualizador: "",
      comentarios: [],
      comentarioCorrela: "",
      acomodar: "",
      acomodare: "",
      retro: false,
      cerrar: true,
      cerrar2: true,
      cerrarTable1: true,
      cerrarTable2: false,
      Tabla1: true,
      adams: false,
      loading: false,
      currentPage: 1,
      itemsPerPage: 4,
      filterField: "",
    };
  },

  async mounted() {
    let parametro = this.$route.params.id;
    console.log(parametro);
    this.permisoVisualizador = localStorage.getItem("idPerfil");
    this.forms.idUsuario = localStorage.getItem("userId");

    // let estado = await axios.get("https://localhost:44319/api/SolicitudPostulante/ObtenerEstado/")
    // console.log(estado.data)

    // let response = await this.axios.get(
    //   "SolicitudPostulante/Obtener/" + parametro
    // );
    // console.log(response.data);
    // this.info = response.data;
    this.getAttributes();

    let comentario = await this.axios.get("ParametroData/Parametro/7507");
    this.comentarios = comentario.data;
  },
  computed: {
    totalPages() {
      return Math.ceil(this.info.length / this.itemsPerPage);
    },
    paginatedInfo() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.info.slice(start, start + this.itemsPerPage);
    },
    comentariosFiltrados() {
      // Filtra los comentarios basados en algún criterio
      // En este ejemplo, excluiremos los elementos con parCorrelativo "elemento_no_deseado"
      return this.comentarios.slice(5, this.comentarios.length).filter(coment => coment.parCorrelativo !== '031');
    },

    fechaMinima() {
    const hoy = new Date();
    const año = hoy.getFullYear();
    const mes = String(hoy.getMonth() + 1).padStart(2, '0');
    const dia = String(hoy.getDate()).padStart(2, '0');
    
    return `${año}-${mes}-${dia}`; // Retorna "2026-02-17"
  }
  },

  methods: {
    async getAttributes() {
      let parametro = this.$route.params.id;

      let response = await this.axios.get(
        "SolicitudPostulante/Obtener/" + parametro
      );
      console.log(response.data);
      this.info = response.data;
    },

    filter(items) {
      // aqui nos aseguramos que el input contenga caracteres String y que valida
      // el v-model de this.nombre
      this.dni_busqueda.length < 3 ? (this.adams = false) : (this.adams = true);

      return (
        items.nombre
          .toLocaleLowerCase()
          .indexOf(this.dni_busqueda.toLocaleLowerCase()) >= 0
      );
    },

    datosIni(post) {
      // this.forms.IdSolxPostulante = id
      // this.forms.FecIniContratos = event
      // console.log(post.fecIniContrato);
      // console.log(post.idSolxPostulante);

      const from = {
        idSolxPostulante: post.idSolxPostulante,
        idUsuario: this.forms.idUsuario,
        fecIniContratos: post.fecIniContrato,
        fecFinContratos: "1900-01-01",
      }

      this.axios.put("SolicitudPostulante/ModificarFecContrato", from).then(r => {
        if (r.data) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "¡Cambio de fecha Inicio Realizado!",
            showConfirmButton: false,
            timer: 1000,
          });
        }

      })
    },

    datosFin(post) {
      // this.forms.IdSolxPostulante = id
      // this.forms.FecFinContratos = event
      const from = {
        idSolxPostulante: post.idSolxPostulante,
        idUsuario: this.forms.idUsuario,
        fecIniContratos: "1900-01-01",
        fecFinContratos: post.fecFinContrato,
      }

      this.axios.put("SolicitudPostulante/ModificarFecContrato", from).then(r => {
        if (r.data) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "¡Cambio de fecha fin Realizado!",
            showConfirmButton: false,
            timer: 1000,
          });
        }

      })
    },

    // actualizarFec(solxPos) {
    //   console.log(solxPos);
    //   this.forms.IdSolxPostulante = solxPos;
    //   console.log(this.forms);

    // axios.put("https://localhost:7059/api/SolicitudPostulante/ModificarFecContrato", this.forms).then( r=>{
    //   console.log(r)
    // })
    //prueba

    // if(this.forms.FecFinContratos == "" && this.forms.FecIniContratos != ""){
    //   for(let items of this.info){
    //   if(solxPos == items.idSolxPostulante){
    //     this.forms.FecFinContratos =items.fecFinContrato

    //     this.axios.put("SolicitudPostulante/ModificarFecContrato", this.forms).then( r=>{

    //   if (r.data == true) {
    //       Swal.fire({
    //         position: "center",
    //         icon: "success",
    //         title: "¡Cambio de fechas Realizado!",
    //         showConfirmButton: false,
    //         timer: 1500,
    //       });
    //     }
    // })
    //   }
    // }

    // }else if(this.forms.FecIniContratos == "" && this.forms.FecFinContratos != ""){
    //   for(let items of this.info){
    //   if(solxPos == items.idSolxPostulante){
    //     this.forms.FecIniContratos = items.fecIniContrato
    //     console.log(items.fecIniContrato)
    //     console.log(this.forms)
    //     this.axios.put("SolicitudPostulante/ModificarFecContrato", this.forms).then( r=>{

    //   if (r.data == true) {
    //       Swal.fire({
    //         position: "center",
    //         icon: "success",
    //         title: "¡Cambio de fechas Realizado!",
    //         showConfirmButton: false,
    //         timer: 1500,
    //       });
    //     }
    // })
    //   }
    // }

    // }else if(this.forms.FecIniContratos == "" && this.forms.FecFinContratos == ""){
    //   console.log(solxPos)
    //   for(let items of this.info){
    //     if(solxPos == items.idSolxPostulante){
    //       this.forms.FecIniContratos = items.fecIniContrato
    //       this.forms.FecFinContratos =items.fecFinContrato
    //       this.forms.IdSolxPostulante = solxPos
    //       console.log(this.forms)
    //       this.axios.put("SolicitudPostulante/ModificarFecContrato", this.forms).then( r=>{

    //   if (r.data == true) {
    //       Swal.fire({
    //         position: "center",
    //         icon: "success",
    //         title: "¡Cambio de fechas Realizado!",
    //         showConfirmButton: false,
    //         timer: 1500,
    //       });
    //     }
    // })

    //     }
    //   }

    // }else{
    //   this.axios.put("SolicitudPostulante/ModificarFecContrato", this.forms).then( r=>{

    //   if (r.data == true) {
    //       Swal.fire({
    //         position: "center",
    //         icon: "success",
    //         title: "¡Cambio de fechas Realizado!",
    //         showConfirmButton: false,
    //         timer: 1500,
    //       });
    //     }
    // })
    // }
    // },

    async CrearUser(postulante) {
      this.acomodar = postulante;
      let idPostulante = postulante;

      const user = {
        idPostulante,
      };

      let respuesta = await this.axios.post(
        "UsuarioPostulante/Registrar",
        user
      );
      console.log(respuesta);

      // console.log()

      this.getAttributes();
    },

    comenta(event, idSolxPostulante, solPosMotivos, solComentario) {
      console.log(event.target.value);
      this.comentarioCorrela = event.target.value;
      this.mandarComentarios(idSolxPostulante, solPosMotivos, solComentario);
    },


    cambiarReferido(idSolxPostulante) {
      this.axios
        .put("SolicitudPostulante/ModificarSolReferido", { idSolxPostulante })
        .then((r) => {
          console.log(r.data);
          this.getAttributes();
        });
    },

    editSeleccion(id) {
      this.$router.push("/contratosEstadoSeleccion/" + id);
      window.scroll(0, 0);
    },

    editEntrevista(id) {
      this.$router.push("/datosEntrevista/" + id);
      window.scroll(0, 0);
    },
    editDocumentos(id) {
      this.$router.push("/datosDocmuentos/" + id);
      window.scroll(0, 0);
    },
    editCapacitaciones(id) {
      this.$router.push("/datosCapacitaciones/" + id);
      window.scroll(0, 0);
    },
    editContrato(id) {
      this.$router.push("/contratosEstadoContrat/" + id);
      window.scroll(0, 0);
    },
  },
};
</script>

<style scoped>
.tabla {
  background: rgb(24, 147, 196);
}

.bg-solimano {
  background: #0080c8;
}

.agrandar {
  width: 280px;
}

.tamaño {
  font-size: 0.65rem;
}

.btn-solimano {
  background: #0080c8;
}

.referido {
  width: 150px;
}
</style>
